import Reveal from '@/components/base/Reveal';

const testimonials = [
  {
    name: '김민준',
    role: '구매자 · 스타트업 마케터',
    quote: '찾던 자동화 매크로를 한 번에 구매했어요. 업무 시간이 정말 많이 줄었습니다.',
    tone: 'bg-primary-500/20 text-primary-300',
  },
  {
    name: '박서연',
    role: '판매자 · 노션 템플릿 크리에이터',
    quote: '판매자 등록이 간단해서 바로 상품을 올렸고, 첫 달에 꾸준히 팔리고 있어요.',
    tone: 'bg-accent-500/20 text-accent-300',
  },
  {
    name: '이지훈',
    role: '구매자 · 인디 게임 개발자',
    quote: '게임 소스코드를 구매해서 개발 시간을 절반으로 줄였습니다. 강력 추천해요.',
    tone: 'bg-secondary-500/20 text-secondary-300',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-xs font-mono uppercase tracking-[0.25em] text-primary-500 whitespace-nowrap">
              testimonials
            </span>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-normal tracking-tight text-white">
              실제 사용자들의 목소리
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, index) => (
            <Reveal key={t.name} delay={index * 80}>
              <div className="h-full rounded-2xl glass-card border border-white/8 p-6 flex flex-col">
                <div className="flex text-accent-500">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="mt-4 text-foreground-200 leading-relaxed flex-1">“{t.quote}”</p>
                <div className="mt-6 flex items-center gap-3">
                  <span className={`w-11 h-11 flex items-center justify-center rounded-full font-heading font-semibold ${t.tone}`}>
                    {t.name[0]}
                  </span>
                  <div>
                    <div className="font-semibold text-white text-sm">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}